import { useAtomValue } from 'jotai';

import { css } from '@flipster/styled-system/css';

import { Accordion } from '../../../../../shared/faq-accordion';
import { useProductConfig } from '../../product-config';

export const FaqTab = () => {
  const { detailsAtom, getFaqItems } = useProductConfig();
  const details = useAtomValue(detailsAtom);
  const faqItems = getFaqItems(details);

  return (
    <Accordion.Root headingLevel={3}>
      {faqItems.map((faq, index) => (
        <Accordion.Item key={index}>
          <Accordion.Header index={index + 1}>{faq.title}</Accordion.Header>
          <Accordion.Panel>
            <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>{faq.description}</p>
          </Accordion.Panel>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
};
